// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"fbf1b86f","703":"9a4e1066","787":"404470a8"}[chunkId] + ".chunk.js";
};